const Heading = ({ item }) => {
  return (
    <>
    {item.content?.trim() ?
    <div className='d-flex flex-column gap-1'>
      <p className='heading fs-18 text-black lh-1'>{item.content}</p>
      <p className='text text-black fs-13 lh-1'>{item.answer}</p>
    </div> : <></>}
    </>
  )
}

export default Heading